// OwnClientDrawer's reads and write (finance-real, the user 2026-10-22): the own client set now, the clients to pick from,
// and setting it on main's route (useSetOwnClient), which the drawer hands its form.
import type { UseMutationResult, UseQueryResult } from "@tanstack/react-query";
import { useOwnClient, useSetOwnClient } from "../../hooks/useLedger";
import { useClientSummaries } from "../../hooks/useReports";
import type { ClientsResponse, OwnClient } from "../../types";

export interface OwnClientDrawerModel {
  own: UseQueryResult<OwnClient>;
  clients: UseQueryResult<ClientsResponse>;
  /** Sets the client by id, or none with null. */
  save: UseMutationResult<OwnClient, Error, string | null>;
}

export function useOwnClientDrawer(): OwnClientDrawerModel {
  const own = useOwnClient();
  const clients = useClientSummaries();
  const save = useSetOwnClient();
  return { own, clients, save };
}
